<template>
  <div class="w-full flex justify-center p-4">
    <!-- Loading State -->
    <div v-if="loadingInitialData" class="w-full flex justify-center items-center fade-in" style="max-width: 1104px; height: calc(100vh - 250px);">
      <div class="flex flex-col items-center">
        <BaseLoadingLogo noPadding :margin="0" :width="48" :height="48" />
        <BaseText type="label" size="sm" class="text-text-subdued mt-5">
          Checking for existing listing
        </BaseText>
        <BaseText type="body" size="sm" class="text-text-disabled mt-1">
          Hang tight...
        </BaseText>
      </div>
    </div>
    <!-- View States -->
    <transition name="view" mode="out-in">
      <CreateDirectoryListing 
        v-if="!loadingInitialData && viewMode === 'create'" 
        @createDirectoryListing="showCreateAgencyListingModal = true" 
      />
      <ViewDirectoryListing 
        v-else-if="!loadingInitialData && viewMode === 'view'"
        :listing="existingListing"
        @editListing="handleEditListing"
      />
      <EditDirectoryListing
        v-else-if="!loadingInitialData && viewMode === 'edit'"
        :generatedListing="generatedListing"
        @listingSubmitted="handleListingSubmitted"
        @cancel="handleCancelEdit"
      />
    </transition>
    <!-- Create Agency Listing Modal -->
    <CreateAgencyListingModal 
      v-if="showCreateAgencyListingModal"
      @generatedListing="handleListingGenerated"
      @close="showCreateAgencyListingModal = false"
    />
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import FirebaseAPI from '@/api/firebase'

import CreateDirectoryListing from './CreateDirectoryListing.vue'
import ViewDirectoryListing from './ViewDirectoryListing.vue'
import EditDirectoryListing from './EditDirectoryListing.vue'
import CreateAgencyListingModal from './CreateAgencyListingModal.vue'

export default {
  name: 'AgencyDirectorySettings',
  components: {
    CreateDirectoryListing,
    ViewDirectoryListing,
    EditDirectoryListing,
    CreateAgencyListingModal
  },
  data () {
    return {
      viewMode: 'create',
      showCreateAgencyListingModal: false,

      existingListing: null,
      generatedListing: null,

      loadingInitialData: true,
    }
  },
  async mounted () {
    // Check for an existing listing associated with the team
    try {
      const existingListing = await FirebaseAPI.Agency.getListingByTeamId(this.getTeam?.id)
      if (existingListing) {
        this.existingListing = existingListing
        this.viewMode = 'view'
      } else {
        this.viewMode = 'create'
      }
    } catch (error) {
      this.$showAlert({
        type: 'error',
        message: 'Error checking for existing listing'
      })
      console.error('Error checking for existing listing: ', error)
    } finally {
      this.loadingInitialData = false
    }
  },
  beforeDestroy () {
    this.SET_SETTINGS_DRAWER_SAVE_GUARD(null)
  },
  watch: {
    viewMode (mode) {
      if (mode === 'edit') {
        this.SET_SETTINGS_DRAWER_SAVE_GUARD("You haven't submitted your listing yet. Are you sure you want to exit?")
      } else {
        this.SET_SETTINGS_DRAWER_SAVE_GUARD(null)
      }
    }
  },
  computed: {
    ...mapGetters('AuthModule', ['getTeam']),
  },
  methods: {
    ...mapMutations('MiscModule', ['SET_SETTINGS_DRAWER_SAVE_GUARD']),
    handleListingGenerated (listing) {
      this.generatedListing = listing
      this.viewMode = 'edit'
    },
    handleListingSubmitted (listing) {
      this.existingListing = listing
      this.viewMode = 'view'
    },
    handleEditListing (listing) {
      this.generatedListing = listing
      this.viewMode = 'edit'
    },
    handleCancelEdit () {
      if (this.existingListing) {
        this.viewMode = 'view'
      } else {
        this.viewMode = 'create'
      }
    }
  }
}
</script>

<style scoped>
.view-enter-active { transition: opacity 150ms ease-in-out; }
.view-enter-from, .view-enter { opacity: 0; }
.view-enter-to { opacity: 1; }
</style>